var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "steps-container",
    class: {
      toc: _vm.toc,
      'vertical-style': _vm.vertical
    },
    attrs: {
      "id": "v-stepper"
    }
  }, _vm._l(_vm.labels, function (step, index) {
    return _c('VStepperStep', {
      key: step,
      attrs: {
        "step-number": index + 1,
        "step-title": step,
        "vertical": _vm.vertical,
        "visited": _vm.checkIfVisited(index + 1),
        "active": _vm.activeStep(index + 1),
        "toc": _vm.toc,
        "hide-not-visited": _vm.hideNotVisited
      },
      on: {
        "clicked": _vm.emitStepChanged
      }
    });
  }), 1);

}
var staticRenderFns = []

export { render, staticRenderFns }